import css from './Artist.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Breakpoints } from 'meta/layout/breakpoints'

import { Grid, GridColumn } from 'components/Layout/Grid'
import { MockCollectionAnchorable } from 'components/Pages/Collection/mock'

import Multiple from './Multiple/Multiple'
import Single from './Single/Single'

interface Props {
  codes: string[]
  setShowLineupModal: (show: boolean) => void
}

const Artist: React.FC<MockCollectionAnchorable & Props> = (props) => {
  const { codes, anchorId, setShowLineupModal } = props

  const isSingleArtist: boolean = codes && codes.length == 1

  const { t } = useTranslation()

  return (
    <Grid>
      <GridColumn
        gridColumnStart={1}
        gridColumnEnd={{ [Breakpoints.tablet]: isSingleArtist ? 9 : 17, [Breakpoints.mobile]: 17 }}
      >
        <div className={css.artistContainer}>
          <h2 className={css.title} id={anchorId}>
            {t('collection:artist_title')}
          </h2>
          {codes && codes.length == 1 && <Single code={codes[0]} />}
          {codes && codes.length > 1 && <Multiple codes={codes} setShowLineupModal={setShowLineupModal} />}
        </div>
      </GridColumn>
    </Grid>
  )
}

export default Artist
